// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"59":"8b2367c0","575":"285a2f7d","925":"fb8250a9"}[chunkId] + ".css";
};